import { render, staticRenderFns } from "./areachart.vue?vue&type=template&id=a23bba50&scoped=true&"
import script from "./areachart.vue?vue&type=script&lang=js&"
export * from "./areachart.vue?vue&type=script&lang=js&"
import style0 from "./areachart.vue?vue&type=style&index=0&id=a23bba50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23bba50",
  null
  
)

export default component.exports